import { PopoverTrigger as ChakraPopoverTrigger } from '@chakra-ui/react'

export const PopoverTrigger: React.FC<React.PropsWithChildren<unknown>> =
  ChakraPopoverTrigger

export {
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverFooter,
  PopoverHeader,
} from '@chakra-ui/react'

export type {
  PopoverArrowProps,
  PopoverBodyProps,
  PopoverCloseButtonProps,
  PopoverContentProps,
  PopoverFooterProps,
  PopoverHeaderProps,
  PopoverProps,
} from '@chakra-ui/react'
